import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const items = [
  ['INÍCIO', '#inicio'],
  ['QUEM SOMOS', '/quem-somos'],
  ['IMÓVEIS', '/imoveis'],
  ['VENDA', '/imoveis?finalidade=Venda'],
  ['LOCAÇÃO', '/imoveis?finalidade=Locação'],
  ['AVALIAÇÃO', '/avaliacao'],
  ['SEGURO', '/contato?assunto=Seguro'],
  ['CONTATO', '/contato'],
] as const;

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const go = (target: string) => {
    setOpen(false);
    if (!target.startsWith('#')) return navigate(target);
    if (location.pathname !== '/') return navigate(`/${target}`);
    document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <button className="site-brand" onClick={() => navigate('/')} aria-label="Página inicial">
          <img className="site-navbar-logo" src="/navbar-logo-v2.png" alt="BNI Bertoncello Negócios Imobiliários" />
        </button>

        <div className="site-header-right">
          <div className="site-contact-row">
            <a href="tel:+554991950002"><i className="ri-whatsapp-line" />(49) 9 9195-0002</a>
            <span className="site-divider" />
            <a href="mailto:mauricio@grupobni.com.br"><i className="ri-mail-line" />mauricio@grupobni.com.br</a>
            <span className="site-divider" />
            <a href="#" aria-label="Facebook"><i className="ri-facebook-circle-fill social-icon" /></a>
            <a href="#" aria-label="Instagram"><i className="ri-instagram-line social-icon" /></a>
          </div>

          <nav className="site-nav" aria-label="Navegação principal">
            {items.map(([label, target], index) => (
              <button key={label} className={index === 0 && location.pathname === '/' ? 'active' : ''} onClick={() => go(target)}>
                {label}
              </button>
            ))}
            <a className="header-whatsapp" href="https://wa.me/554991950002">
              <i className="ri-whatsapp-line" /> FALE CONOSCO
            </a>
          </nav>
        </div>

        <button className="site-menu-toggle" onClick={() => setOpen(!open)} aria-label={open ? 'Fechar menu' : 'Abrir menu'}>
          <i className={open ? 'ri-close-line' : 'ri-menu-line'} />
        </button>
      </div>

      {open && (
        <nav className="site-mobile-nav" aria-label="Navegação móvel">
          {items.map(([label, target]) => <button key={label} onClick={() => go(target)}>{label}</button>)}
          <a href="https://wa.me/554991950002"><i className="ri-whatsapp-line" /> FALE CONOSCO</a>
        </nav>
      )}
    </header>
  );
}
